import Image from 'next/image';

import { getAssetUrl } from '@/utils/getAssetUrl';
import { graphql, readFragment, type FragmentOf } from '@/utils/graphql';

export const profilePictureFragment = graphql(`
  fragment profilePictureFields on profiles {
    name
    picture {
      id
    }
  }
`);

export function ProfilePicture({
  profile: _profile,
  options,
}: {
  profile: FragmentOf<typeof profilePictureFragment>;
  options: {
    width: number;
    height: number;
    priority?: boolean;
  };
}) {
  const profile = readFragment(profilePictureFragment, _profile);

  if (!profile.picture) {
    const initials = profile.name.substring(0, 1).toUpperCase();

    return (
      <div
        className="relative inline-flex items-center justify-center overflow-hidden bg-secondary rounded-full flex-none"
        style={{ width: options.width, height: options.height }}
      >
        <span className="font-medium text-primary">{initials}</span>
      </div>
    );
  }

  return (
    <Image
      src={getAssetUrl(profile.picture.id, {
        width: options.width * 2,
        height: options.height * 2,
      })}
      width={options.width}
      height={options.height}
      alt={`Foto de perfil de ${profile.name}`}
      className="bg-secondary rounded-full max-w-none"
      priority={options.priority || false}
      unoptimized
    />
  );
}
